/**
 * Single source of truth for route paths.
 *
 * The site is a single page: everything commercial lives at `/` and is reached
 * by anchor, see `sections.ts`. The legal pages stay as their own routes
 * because they need to be linkable and citable on their own.
 */
export const ROUTES = {
  home: '/',
  privacy: '/privacy',
  terms: '/terms',
  notFound: '*',
} as const;
